enum FileType {
    Default = 1,
    Pdf = 2,
    Word = 3,
    Excel = 4
}

export default FileType;
